<template>
    <UsersNetworkModal
        v-model="form"
        @onConfirm="onClickConfirm"
        :is-loading="isLoading"
        :title="$t('title')"
        :btn-confirm-text="$t('btnConfirmText')"
        translation="2"
    />
</template>

<script>
import api from '@/services/api'
import Swal from 'sweetalert2'
import UsersNetworkModal from '../users-network-modal/UsersNetworkModal'

export default {
    name: 'ClearUsersNetwork',
    components: {
        UsersNetworkModal,
    },
    props: {
        users: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            form: {
                updateLeader: false,
                updateTeam: false,
                updatePeers: false,
            },
            isLoading: false,
        }
    },
    methods: {
        onClickConfirm(routerBack, success, error) {
            Swal.queue([
                {
                    type: 'warning',
                    title: this.$t('notification.warning'),
                    text: this.$tc('confirmMessage', this.users.length >= 1 ? 1 : 2),
                    confirmButtonText: this.$t('notification.yes'),
                    confirmButtonColor: '#20A8D8',
                    cancelButtonText: this.$t('notification.no'),
                    showLoaderOnConfirm: true,
                    showCancelButton: true,
                    preConfirm: () => {
                        this.isLoading = true
                        const { updateLeader, updateTeam, updatePeers } = this.form
                        api.post('users/bulk/clear-users-network', {
                            users_ids: this.users,
                            types: {
                                leader: updateLeader,
                                team: updateTeam,
                                peer: updatePeers,
                            },
                        })
                            .then(() => {
                                success()
                            })
                            .catch(() => {
                                error()
                            })
                            .finally(() => {
                                this.isLoading = false
                                routerBack()
                            })
                    },
                },
            ])
        },
    },
    i18n: {
        messages: {
            'pt-BR': {
                confirmMessage:
                    'Você realmente deseja limpar a rede dos usuários selecionados? Não será possível reverter esta operação.' +
                    ' | ' +
                    'Como nenhum usuário foi selecionado será apagada a rede de todos os usuários. Não será possível reverter esta operação. Tem certeza que deseja prosseguir?',
                title: 'Limpar rede dos usuários',
                btnConfirmText: 'Limpar',
            },
            'en-US': {
                confirmMessage:
                    "Do you really want to clear the selected users' network? It'll not be possible to reverse this operation." +
                    ' | ' +
                    'As no user was selected, the network of all users will be deleted. It will not be possible to reverse this operation. Are you sure you want to proceed?',
                title: 'Clear users network',
                btnConfirmText: 'Clear',
            },
            'es-ES': {
                confirmMessage:
                    '¿Realmente desea borrar la red de los usuarios seleccionados? No será posible revertir esta operación.' +
                    ' | ' +
                    'Como no se seleccionó ningún usuario, se eliminará la red de todos los usuarios. No será posible revertir esta operación. ¿Estas seguro que deseas continuar?',
                title: 'Borrar red de usuarios',
                btnConfirmText: 'Borrar',
            },
        },
    },
}
</script>
